/**
 * FRIDGE-760 — retailer-CTA tone on a product with an active CPSC recall.
 *
 * The RecallBanner header had promised for months that the product page
 * "replaces 'Buy now' CTA visual prominence with 'Learn about this recall'".
 * The page never did it: nine live Smeg pages rendered the red recall card
 * directly above three full-strength orange View buttons (09/04/2026).
 *
 * The rule, in one place so every CTA site and the guard test read it:
 *   - with an active recall, every retailer button on the page drops to the
 *     SECONDARY tone — still a working purchase path, never hidden (a
 *     legitimate way to buy is never removed by us);
 *   - the PRIMARY tone moves to one "Learn about this recall" link that
 *     scrolls to the banner (#recall-banner).
 * Pure: no React, no DOM.
 */
import type { FinRecall } from '@/components/product/RecallBanner'

/** The site's filled-orange buy button (brand orange #ff9951 — never re-darkened). */
export const PRIMARY_OFFER_CTA = 'bg-[#ff9951] hover:bg-[#ff8533] text-[var(--color-brand-action-text)]'
/** The de-emphasized buy button: white field, orange text, hairline. Same size, same click. */
export const SECONDARY_OFFER_CTA = 'bg-white text-[#ff8533] border border-[#ff9951]/60 hover:bg-[#ff9951]/10'
/** The banner's anchor id; the "Learn about this recall" link scrolls here. */
export const RECALL_BANNER_ID = 'recall-banner'

export function hasActiveRecall(recalls: ReadonlyArray<Pick<FinRecall, 'status'>> | null | undefined): boolean {
  return !!recalls && recalls.some((r) => r.status === 'active')
}

/** The tone class for a retailer CTA given the page's recall state. */
export function offerCtaTone(activeRecall: boolean): string {
  return activeRecall ? SECONDARY_OFFER_CTA : PRIMARY_OFFER_CTA
}
